import React from "react";
import {
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  useRedirect,
  useRefresh,
  CreateProps,
} from "react-admin";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import CreateWrapper from "../../components/CreateWrapper";

interface ICustomRedirect {
  data: IArea;
}

const AreasCreate = (props: CreateProps) => {
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Areas", link: `/schools/${param.get("schoolId")}/show/3` },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = ({ data }: ICustomRedirect) => {
    redirect(`/schools/${data.schoolId}/show/3`);
    refresh();
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Subcontractor Area"
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <NumberInput source="maxDistanceInMeters" validate={required()} />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default AreasCreate;
